import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import AlertDialog from '../../components/Dialog/alertDialog';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import queryString from 'query-string';
import { facilityTypes } from '../facilitiesMangementScreen/facilities';
import { IGeneralAdStore } from '../../mobx-store/storeInterfaces/generalAdInterface';

interface IProps extends WithSnackbarProps {
  generalAdsStore: IGeneralAdStore;
  countryStore: CountryStore;
  history: any;
  match: any;
  location: any;
}

interface IState {
  open: boolean;
}

@inject('generalAdsStore')
@inject('countryStore')
@observer
class GeneralAds extends Component<IProps, IState> {
  addButton: any;

  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  facilityCategoryType: string;

  handleAgree: () => void = () => null;

  constructor(props: IProps) {
    super(props);
    this.title = translate('generalAdsListTitle', {
    });
    this.state = {
      open: false,
    };
  }

  async componentWillMount() {
    await this.props.countryStore.getUserManagedCountries();
    await this.props.generalAdsStore.getAllGeneralAds(this.props.countryStore.managedCountries);
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    const id = this.props.generalAdsStore.generalAdsList[index].generalAdId;
    this.props.history.push(`/general-ads/edit/${id}`);
  };

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.handleClickOpen();  
    if(value) {
      this.handleAgree = () => {
        this.props.generalAdsStore.activateGeneralAd(this.props.generalAdsStore.generalAdsList[index].generalAdId, this.props.countryStore.managedCountries)
          .then(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
            }), 8000, 'success');
          })
          .catch((error: any) => {
            SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
            }), 8000, 'error');
          });
        this.setState({
          open: false,
        });
      };
    } else {
        this.props.generalAdsStore.deactivateGeneralAd(this.props.generalAdsStore.generalAdsList[index].generalAdId, this.props.countryStore.managedCountries)
        .then(() => {
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 8000, 'success');
        })
        .catch((error: any) => {
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
        this.setState({
          open: false,
        });
      }
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleAdd = (): void => {
    this.props.history.push(`/general-ads/new`);
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  getTableHeader = () => [
    {
      title: translate('generalAdsTitleColumnTitle', {
      }),
    },
    {
      title: translate('generalAdsIsActiveColumnTitle', {
      }),
    },
    {
      title: translate('generalAdsEditColumnTitle', {
      }),
    },
  ];

  getAddButton = () => ({
    title: translate('addButton', {
    }),
    onAdd: this.handelAdd,
  });

  handelAdd = (): void => {
    this.props.history.push('/general-ads/new');
  };

  getTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  getTableData = () => {

    return this.props.generalAdsStore.generalAdsList.map(item => {

      return {...item, edit: 'Edit'}
    })
  }

  render() {
    this.addButton = this.getAddButton();
    this.tableHeader = this.getTableHeader();
    this.tableCellTypes = this.getTableCellTypes();

    return (
      <div>
        <div>
          <GeneralTableComponent
            emptyMessage={translate('generalAdsEmptyMessage', {
            })}
            title={this.title}
            tableHeader={this.tableHeader}
            tableData={this.getTableData()}
            tableCellTypes={this.tableCellTypes}
            addButton={this.addButton}
            loadingStatus={[
              this.props.generalAdsStore.getGeneralAdsRequestStatus,
              this.props.countryStore.getManagedCountriesRequestStatus
            ]}
          />
        </div>
        <div>
          <AlertDialog
            title="Wadi Degla Dashboard"
            content={translate('activateGeneralAdAlert', {
            })}
            isOpen={this.state.open}
            agree={this.handleAgree}
            disAgree={this.handleClose}
            hasActions
          />
        </div>
      </div>
    );
  }

}

export default GeneralAds;
